import { ruleMessage } from '@cnamts/vue-dot/src//helpers/ruleMessage';
import { ErrorMessages } from '@cnamts/vue-dot/src/rules/types';
import { calcHumanFileSize } from '@cnamts/vue-dot/src/functions/calcHumanFileSize';

const fileSizeUnits = [
	'o',
	'Ko',
	'Mo',
	'Go',
	'To'
];

const defaultErrorMessages: ErrorMessages<number> = {
	default: (max: number) => `La taille maximum est ${calcHumanFileSize(max, fileSizeUnits)}.`
};

/** Check that the file does not exceeds the max size in byte */
export function fileMaxSize(max: number, errorMessages = defaultErrorMessages) {
	// Return the validation function
	return (value: File) => {
		// If the value is empty, return true (valid)
		if (!value || (Array.isArray(value) && !value.length)) {
			return true;
		}

		return value.size < max || ruleMessage(errorMessages, 'default', [max]);
	};
}

export default fileMaxSize;
